import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule, Sparkles, Download, X } from 'lucide-angular';
import { PwaInstallService } from '../../../services/pwa-install.service';

@Component({
  selector: 'app-install-prompt',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './install-prompt.component.html',
  styleUrl: './install-prompt.component.scss'
})
export class InstallPromptComponent {
  readonly pwaService = inject(PwaInstallService);

  readonly Sparkles = Sparkles;
  readonly Download = Download;
  readonly X = X;

  install(): void {
    this.pwaService.promptInstall();
  }

  dismiss(): void {
    this.pwaService.dismissPrompt();
  }
}
